import { Injectable, inject } from "@angular/core";
import { AuthenticationService } from "core/authentication.service";
import { EntryPageResource } from "core/stages-client";

type EntryPage = stages.entrypage.EntryPage;
type EntryPageTab = stages.entrypage.EntryPageTab;

@Injectable({ providedIn: "root" })
export class EntryPagesService {
	private readonly entryPageResource = inject(EntryPageResource);
	readonly authenticationService = inject(AuthenticationService);

	entryPagesMap: Map<string, { version: number; page: EntryPage }>;

	constructor() {
		const authenticationService = this.authenticationService;

		this.entryPagesMap = new Map<string, { version: number; page: EntryPage }>();
		authenticationService.invalidateCaches$.subscribe(() => this.invalidateCache());
	}

	async getEntryPage(tab: EntryPageTab): Promise<EntryPage> {
		const cacheEntry = this.entryPagesMap.get(tab.id);
		if (cacheEntry && cacheEntry.version === tab.version) {
			return cacheEntry.page;
		}
		const entryPage = await this.refreshEntryPage(tab);
		this.entryPagesMap.set(tab.id, { version: tab.version, page: entryPage });
		return entryPage;
	}

	async refreshEntryPage(tab: EntryPageTab): Promise<EntryPage> {
		const refreshedPage = await this.entryPageResource.getEntryPage(tab.id);
		this.entryPagesMap.delete(tab.id);
		return refreshedPage;
	}

	private invalidateCache(): void {
		this.entryPagesMap.clear();
	}
}
